import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, CardContent, Typography } from '@mui/material';
const PaymentMethodInfo = () => {
  return (
    <Box
      sx={{
        p: 4,
        maxWidth: 800,
        mx: 'auto',
        backgroundColor: '#e3f2fd',
        borderRadius: '8px',
      }}
    >
      <Box sx={{ borderLeft: '4px solid #1976d2' }}>
        <CardContent
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0.5rem 0.5rem 0.5rem 1rem',
          }}
        >
          <InfoOutlinedIcon
            style={{ color: '#1976d2', marginRight: '0.75rem' }}
          />{' '}
          <Typography
            variant='body1'
            component='div'
            style={{ color: '#424242' }}
          >
            Choose how you'd like to pay
          </Typography>
        </CardContent>
      </Box>
    </Box>
  );
};
export default PaymentMethodInfo;
